import { footerLinks } from '@/mocks/homeData';

export default function Footer() {
  const handleNavClick = (href: string) => {
    if (href.startsWith('#')) {
      const el = document.querySelector(href);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="w-full bg-foreground-900 text-background-200">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8 md:gap-10">
          <div className="lg:col-span-2">
            <span className="text-xl md:text-2xl font-heading text-background-50 mb-3 block">
              51吃瓜网
            </span>
            <p className="text-sm text-background-400 leading-relaxed mb-4 max-w-[320px]">
              51吃瓜网今日吃瓜资源 — 国内领先的娱乐资讯聚合平台，提供51吃瓜官网全网最新入口、轻量版和APP客户端下载，
              手机网页版稳定访问官方入口地址，随时随地获取最新吃瓜内容。
            </p>
            <div className="flex items-center gap-3">
              <a href="#contact" onClick={(e) => { e.preventDefault(); handleNavClick('#contact'); }} className="w-9 h-9 flex items-center justify-center rounded-md bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-mail-line"></i>
              </a>
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-wechat-line"></i>
              </span>
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-weibo-line"></i>
              </span>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">关于</h4>
            <ul className="space-y-2.5">
              {footerLinks.about.map((link, i) => (
                <li key={i}>
                  <a
                    href={link.href}
                    onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">下载</h4>
            <ul className="space-y-2.5">
              {footerLinks.download.map((link, i) => (
                <li key={i}>
                  <a
                    href={link.href}
                    onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">热门</h4>
            <ul className="space-y-2.5">
              {footerLinks.hot.map((link, i) => (
                <li key={i}>
                  <a
                    href={link.href}
                    onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 md:mt-12 pt-6 md:pt-8 border-t border-background-800">
          <div className="mb-4">
            <h4 className="text-xs font-semibold text-background-500 mb-2">合作伙伴</h4>
            <p className="text-xs text-background-600">感谢各位合作伙伴的支持与信任，期待与更多优秀平台携手共进。</p>
          </div>
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-600">
            <p>&copy; 2020 - 2026 51吃瓜网今日吃瓜资源. All rights reserved.</p>
            <p>本站内容仅供娱乐参考，不构成任何建议。</p>
          </div>
        </div>
      </div>
    </footer>
  );
}